import { useFormik } from "formik";
import { updatePriority } from "../api";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { branches } from "../../../../../store/queries/branches";
import { useDispatch } from "react-redux";

const usePriorityModal = ({
  closeModal,
  branch_currency_id,
  refetch,
  display_order,
}) => {
  const dispatch = useDispatch();
  const validationSchema = Yup.object({
    display_order: Yup.string()
      .required("Priority order is required")
      .matches(/^\d+$/, "Priority order must be a numeric value")
      .test("range", "Priority order must be between 1 and 100", (value) => {
        const num = Number(value);
        return num >= 1 && num <= 100;
      }),
  });
  const formik = useFormik({
    initialValues: {
      display_order: display_order ?? "",
    },
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      let data = {
        display_order: values?.display_order,
        branch_currency_id: branch_currency_id,
      };
      updatePriority(data).then((response) => {
        if (response?.data?.success) {
          toast.success("Priority updated successfully");
          dispatch(branches.util.invalidateTags(["branch-rate"]));
          closeModal();
          setSubmitting(false);
        } else if (response?.data?.status_code === 422) {
          let errors = response?.errors;
          let errorFields = Object.keys(errors);
          errorFields?.forEach((field) => {
            formik.setFieldError(field, errors[field]);
          });
          setSubmitting(false);
        } else if (response?.success === false) {
          let errors = response?.message;
          let errorFields = Object.keys(errors);
          errorFields?.forEach((field) => {
            formik.setFieldError(field, errors[field]);
          });
          setSubmitting(false);
        } else {
          toast.error(response?.data?.message ?? "Something went wrong");
          setSubmitting(false);
        }
      });
    },
  });
  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };
  return {
    formik,
    getFieldError,
  };
};

export default usePriorityModal;
